// complete profile parent component, code included for - checkurl, check subdomain for opening form, cookies set for login user, custom popup for close icon.

// ..........Imports..............
import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";

// ...........CSS imports........
import "../../../assets/css/register/register.css";

// ...........Constant imports.............
import { domains } from "../../../constants/registration";

// ..........Action Imports................
import { createCurrentUrl, certificationPage, getAbsoluteDestinationUrl, IdsCheck ,deviceType} from "../../../utils/registrationUtils";
import {gaEvent, gaLocationAndContentData} from "../../../utils/index";
import { getUserIp, getGeolocationData, postUserProfileClevertap } from "../../../../store/slices/Registration/CommonSlices";

// ...........Component imports...............
import Loading from "../../utils/loader";
import CommonModal from "../../utils/commonModal";
import CareersRegisterLeft from "../CareersRegisterLeft"
import logo from "../../../assets/images/register/logo.svg";
import CareersRegisterCompleteProfile from "./CareersRegisterCompleteProfile";
import axios from "axios";
import DataLayerEvents from "../../common/DataLayerEvents";

const RegisterCompleteProfile = (props) => {
    // State variables
    const [domain, setDomain] = useState(null); // Domain related to the registration process
    const [open, setOpen] = useState(false); // Controls modal visibility
    const [reloadFlagOnExit, setReloadFlagOnExit] = useState(true); // Flag to reload the page on exit
    const [clevertapValues, setClevertapValues] = useState(true); // Values for Clevertap analytics

    // Get URL parameters
    const clickLocation = new URLSearchParams(window.location.search)?.get("click_location") || ''
    const cookies = new Cookies();
    const navigate = useNavigate();

    // Cookies data for login and registration states
    const loginDataCookies = cookies?.get("loginState");
    const signupDataCookies = cookies.get("registrationState");

    // Check and validate the current URL
    const subDomainName = window.location.host?.split(".")[0];
    const urlCheck = window.location.href;
    let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
        window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
    const currentUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
    const sourseDestination = currentUrl ? `${currentUrl}${window.location.search}` : getAbsoluteDestinationUrl();

    // Determine destination domain for cookies domain
    const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
    //---------------------------------------

    // Fetch user IP and set up history state on component mount
    useEffect(() => {
        props.dispatch(getUserIp());

        // Prevent back button navigation
        window.history.pushState(null, "", window.location.href);
        const handlePopstate = (event) => {
            window.location.href = `/user/login${window.location.search}`;
        };
        window.onpopstate = handlePopstate;

        return () => {
            window.onpopstate = handlePopstate; // Clean up the event handler
        };

    }, []);

    // Handle various URL and cookie validations
    useEffect(() => {
        if (!sessionStorage.getItem("loginState")) {
            cookies.remove("loginState", {
                path: "/",
                domain: destinationDomain,
            });
            navigate(`/user/login${window.location.search}`)
        }
        let domainVal;
        if (window.location?.hostname?.includes("localhost")) {
            const urlParams = new URLSearchParams(window.location.search);
            domainVal = urlParams?.get("domain");
        } else if (certificationFormCheck || certificationPage(urlCheck)) {
            domainVal = "certification";
        } else {
            domainVal = window.location.host?.split(".")[0];
        }
        let domainObj = {};
        domainObj = domains.find((obj) => obj.name == domainVal);
        if (!domainObj) {
            domainObj = domains.find((obj) => obj.name == "www");
        }
        setDomain(domainObj);
    }, []);

    // Event for preventing default browser popup on redirecting
    useEffect(() => {
        // Redirect to a specific URL if reloadFlagOnExit is false
        if (!reloadFlagOnExit) window.location.href = currentUrl || createCurrentUrl();

    }, [!reloadFlagOnExit])

    // Fetch geolocation data based on user IP
    useEffect(() => {
        if (props.userIps || props.userIpError) props.dispatch(getGeolocationData({ ip: props.userIps?.ip }))
    }, [props.userIps || props.userIpError])

    // Handle cookies and other data on successful signup
    useEffect(() => {
        // Check if login has proceeded
        if (props.postSignupData?.proceed == true && (props.postSignupData?.cookies || props.postSignupData?.user_session_data)) {
            // Post CleverTap events
            clevertapEvents();
            //post CleverTap user profile data
            postUserProfileClevertapData();
            // -------------- set Login session cookies -----------------
            // Set JWT access cookie
            if(props.postSignupData?.cookies?.c360_jwt_access){
            cookies.set("c360_jwt_access", props.postSignupData?.cookies?.c360_jwt_access, {
                path: "/",
                expires: new Date(props.postSignupData?.cookies?.access_expiry_time),
                domain: destinationDomain,
                sameSite: "Lax"
            })}
            // Set JWT refresh cookie
            if(props.postSignupData?.cookies?.c360_jwt_refresh){
            cookies.set("c360_jwt_refresh", props.postSignupData?.cookies?.c360_jwt_refresh, {
                path: "/",
                domain: destinationDomain,
                expires: new Date(props.postSignupData?.cookies?.refresh_expiry_time),
                sameSite: "Lax"
            })}
             // Set session ID cookie
            if(props.postSignupData?.cookies?.sessionid){
            cookies.set("sessionid", props.postSignupData?.cookies?.sessionid, {
                path: "/",
                domain: destinationDomain,
                expires: new Date(props.postSignupData?.cookies?.session_expiry_time),
                sameSite: "Lax"
            })}
             // Set user session data cookie
            if(props.postSignupData?.user_session_data?.session){
            cookies.set(props.postSignupData?.user_session_data?.session, props.postSignupData?.user_session_data?.sid, {
                path: "/",
                domain: destinationDomain,
                expires: new Date(props.postSignupData?.cookies?.session_expiry_time),
                sameSite: "Lax"
            })}
            // Set CloudFront cookie
            if(props.postSignupData?.user_session_data?.cloudfront_cookie){
            cookies.set(props.postSignupData?.user_session_data?.cloudfront_cookie, props.postSignupData?.user_session_data?.cloudfront_cookie_value, {
                path: "/",
                domain: destinationDomain,
                expires: new Date(props.postSignupData?.cookies?.session_expiry_time),
                sameSite: "Lax"
            })}
            // Remove unnecessary cookies which are created during login or signup and not needed after successful login.
            cookies.remove("registrationState", {
                path: "/",
                domain: destinationDomain,
            });
            cookies.remove("loginState", {
                path: "/",
                domain: destinationDomain,
            });
            cookies.remove("user-agent-key", {
                path: "/",
                domain: destinationDomain,
            });
            cookies.remove("common_embbed_fields", {
                path: "/",
                domain: destinationDomain,
            });
            // rediercting to destination URL after succesful login.
            if (props.postSignupData?.destination) {
                window.location.href = props.postSignupData?.destination;
            } 
        }
    }, [props.postSignupData])

    // Post user profile data to Clevertap for analytics
    const postUserProfileClevertapData = () => {
        const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
         // Retrieve login data from cookies
        const loginData = cookies.get("loginState")?.formValues;
        let obj = {};
        obj.current_url = sourseDestination || createCurrentUrl();
        obj.certification = domain?.id == 2 ? true : false;
        obj.destination = destinationUrl;
        obj.email = loginData?.email;
        obj.cta_clicked = "login";
        obj.country_code = "+91";
        obj.location = clevertapValues?.location?.id;
        obj.current_location = props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "";
        obj.education_level = clevertapValues?.education_level?.id;
        obj.name = clevertapValues?.studentname?.trim();
        obj.interested_in = clevertapValues.interested_in?.length > 0 ? IdsCheck(clevertapValues?.interested_in) : [];
        obj.user_uuid = loginData?.userUuid;
        obj.user_type = loginData?.user_type;
        obj.checkbox_id = props.tertiaryChecboxData?.id ?? 0;
        obj.checkbox_status = clevertapValues?.tertiary_checkbox?.[0]?.id == 1 ? true : false;
        if (clevertapValues?.passing_year)
            obj.passing_year = clevertapValues?.passing_year?.id;
        if (clevertapValues?.aspiring_stream)
            obj.aspiring_stream = clevertapValues?.aspiring_stream?.id;
        if (clevertapValues?.degree_pursue)
            obj.degree_pursue = clevertapValues.degree_pursue?.id;
        if (clevertapValues?.target_year)
            obj.target_year = clevertapValues.target_year?.id;
        if (clevertapValues?.work_experience)
            obj.work_experience = JSON.stringify(clevertapValues.work_experience?.id);
        if (clevertapValues?.education_interest) {
            if (clevertapValues?.education_interest?.id)
                obj.degree_interested = clevertapValues?.education_interest?.id
            if (clevertapValues?.education_interest?.group_id) {
                obj.is_group = true;
            }
            obj.domain_id = clevertapValues?.education_interest?.domain_id;
        };
        if (clevertapValues.passport?.length > 0)
            obj.passport = clevertapValues.passport?.[0]?.id;
        if (clevertapValues.course_joining_preference)
            obj.course_joining_preference = clevertapValues?.course_joining_preference?.[0]?.id;
        if (clevertapValues.area_of_interest?.length > 0)
            obj.area_of_interest = clevertapValues?.area_of_interest;
        if (clevertapValues?.country?.length > 0)
            obj.country = IdsCheck(clevertapValues?.country);
        if (clevertapValues.certificate_interest)
            obj.certificate_interest = clevertapValues.certificate_interest?.domain_id;
        obj.certification = props.domain?.id == 2 ? true : false;

        props.dispatch(postUserProfileClevertap(obj));
    };

    // Push Clevertap events for analytics
    const clevertapEvents = () => {
        gaEvent("sessionsignin", "login_signup", `${gaLocationAndContentData}`, ""); // on sucessful session start
        let clevertapEventsDataSignup = {};
        clevertapEventsDataSignup.userName = clevertapValues?.studentname;
        clevertapEventsDataSignup.userEmail = loginDataCookies?.formValues?.email;
        clevertapEventsDataSignup.userMobile = loginDataCookies?.formValues?.mobile;
        clevertapEventsDataSignup.studyingIn = clevertapValues?.education_level?.label;
        clevertapEventsDataSignup.location = clevertapValues?.location?.label;
        if (clevertapValues?.education_interest || clevertapValues?.certificate_interest)
            clevertapEventsDataSignup.eduInterest = clevertapValues?.education_interest?.label || clevertapValues?.certificate_interest?.label;
        if (clevertapValues?.target_year)
            clevertapEventsDataSignup.admissionTarget = clevertapValues?.target_year?.label;
        if (clevertapValues?.passing_year) clevertapEventsDataSignup.passingYear = clevertapValues?.passing_year?.label;
        window.dataLayer.push({...clevertapEventsDataSignup, event: "ctsignup"});
    }

    // Handle navigation on modal confirmation
    const handleNavigate = (obj) => {
        if (obj === "yes") {
          cookies.remove("registrationState", {
            path: "/",
            domain: destinationDomain,
          });
          cookies.remove("loginState", {
            path: "/",
            domain: destinationDomain,
          });
          cookies.remove("user-agent-key", {
            path: "/",
            domain: destinationDomain,
          });
          sessionStorage.removeItem("loginState");
          setReloadFlagOnExit(false);
        }
    }

    return (
        <div className="careers_register_main">
            {domain &&
                <>
                    {props.postSignupData?.proceed ?
                    // loader
                        <div className="text-center">
                            <Loading colour={"FFA500"} size={100} />
                        </div> :
                         //Left side content page.
                        <>
                        <DataLayerEvents contentType={"Login/Signup"} pageTypes={"complete_profile"}  verticalName={domain?.domain}/> 
                        <div className="careers_register_leftside">
                            <CareersRegisterLeft />
                        </div>
                            <div tabIndex="0" id="manage_dropdown_leftshift" className="careers_register_rightside">
                                 {/* Complete profile Content page where all forms screens are visible accordingly */}
                                <CareersRegisterCompleteProfile domain={domain}
                                    reloadFlagOnExit={reloadFlagOnExit} setClevertapValues={setClevertapValues} />
                                {/* close icon */}
                                {deviceType == "web" &&
                                    <AiOutlineClose className="close_icon" onClick={() => {
                                        setOpen(true)
                                    }} />}
                            </div></>}

                    {/* opens modal when click on close icons */}
                    <CommonModal
                        isOpen={open}
                        showCloseIcon={false}
                        closeOnOverlayClick={false}
                        closeOnEsc={false}
                        closeModal={() => {
                            setOpen(false);
                        }}
                        classNames={{ root: "continue_modal" }}
                    >
                        <div className="careers_register_modal">
                            <div className="careers_register_modal_header">
                                <img src={logo} alt="logo" />
                            </div>
                            <div className="careers_register_modal_body careers_register_modal_body_back_button">
                                <p>Wait! Your learning journey is just one step away.</p>
                                <p> By exiting , you may not be able to access resources.</p>
                                <p>Do you want to continue?</p>
                                <div className="careers_register_modal_buttons">
                                    <button onClick={() => handleNavigate("yes")} >{deviceType == "mobile" ? "No, exit" : "No, I want to Exit"}</button>
                                    <button className="careers_register_modal_button_active" onClick={() => setOpen(false)}>
                                        {deviceType == "mobile" ? "Yes, Continue" : "Yes,  I want to Continue"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </CommonModal>
                </>}
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        userIps: state.usersCommonData?.userIp,
        userIpError: state.usersCommonData?.userIpError,
        loginDatas: state.usersCommonData?.loginData,
        postSignupData: state.userSignUpFields?.signupData,
        geolocationData: state.usersCommonData?.geoLocation,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterCompleteProfile);